exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-16928a23]{border-collapse:collapse;width:100%;background-color:#fff}td[data-v-16928a23],th[data-v-16928a23]{border:1px solid #ddd;text-align:left;padding:8px}tr[data-v-16928a23]:nth-child(2n){background-color:#eaeaea}.container[data-v-16928a23]{border-style:hidden}.bottom-container[data-v-16928a23]{position:fixed;left:0;bottom:0;width:100%;color:#fff;text-align:center}.nav-button[data-v-16928a23]{display:inline-block;padding:5px 15px;margin-left:13px;margin-right:13px;border:1px solid #fff;font-size:16px;border-radius:5px;background-color:#fff;-webkit-transition-duration:.4s;transition-duration:.4s}.nav-button[data-v-16928a23]:hover{color:#32a6ae}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16928a23","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/displayAndSelect.vue
// module id = 157
// module chunks = 0